type Props = {
  width?: string;
  height?: string;
  viewBox?: string;
  fillColor?: string;
  strokeColor?: string;
  strokeWidth?: string;
};

const CircleArrowRightIcon = (props: Props) => {
  const {
    width = '20',
    height = '21',
    viewBox = '0 0 20 21',
    fillColor = '#848484',
  } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
    >
      <path
        d="M10 2.375C8.39303 2.375 6.82214 2.85152 5.486 3.74431C4.14985 4.6371 3.10844 5.90605 2.49348 7.3907C1.87852 8.87535 1.71762 10.509 2.03112 12.0851C2.34463 13.6612 3.11846 15.1089 4.25476 16.2452C5.39106 17.3815 6.8388 18.1554 8.4149 18.4689C9.99099 18.7824 11.6247 18.6215 13.1093 18.0065C14.594 17.3916 15.8629 16.3502 16.7557 15.014C17.6485 13.6779 18.125 12.107 18.125 10.5C18.1227 8.34581 17.266 6.28051 15.7427 4.75727C14.2195 3.23403 12.1542 2.37727 10 2.375ZM10 17.375C8.64026 17.375 7.31105 16.9718 6.18046 16.2164C5.04987 15.4609 4.16868 14.3872 3.64833 13.1309C3.12798 11.8747 2.99183 10.4924 3.2571 9.15875C3.52238 7.82513 4.17716 6.60013 5.13864 5.63864C6.10013 4.67716 7.32514 4.02237 8.65876 3.7571C9.99238 3.49183 11.3747 3.62798 12.631 4.14833C13.8872 4.66868 14.9609 5.54987 15.7164 6.68045C16.4718 7.81104 16.875 9.14025 16.875 10.5C16.8729 12.3227 16.1479 14.0702 14.8591 15.3591C13.5702 16.6479 11.8227 17.3729 10 17.375ZM13.5672 10.0578C13.6253 10.1159 13.6714 10.1848 13.7029 10.2607C13.7343 10.3365 13.7505 10.4179 13.7505 10.5C13.7505 10.5821 13.7343 10.6635 13.7029 10.7393C13.6714 10.8152 13.6253 10.8841 13.5672 10.9422L11.0672 13.4422C10.9499 13.5595 10.7909 13.6253 10.625 13.6253C10.4592 13.6253 10.3001 13.5595 10.1828 13.4422C10.0655 13.3249 9.99966 13.1659 9.99966 13C9.99966 12.8341 10.0655 12.6751 10.1828 12.5578L11.6164 11.125H6.875C6.70924 11.125 6.55027 11.0592 6.43306 10.9419C6.31585 10.8247 6.25 10.6658 6.25 10.5C6.25 10.3342 6.31585 10.1753 6.43306 10.0581C6.55027 9.94085 6.70924 9.875 6.875 9.875H11.6164L10.1828 8.44219C10.0655 8.32491 9.99966 8.16585 9.99966 8C9.99966 7.83415 10.0655 7.67509 10.1828 7.55781C10.3001 7.44054 10.4592 7.37465 10.625 7.37465C10.7909 7.37465 10.9499 7.44054 11.0672 7.55781L13.5672 10.0578Z"
        fill={fillColor}
      />
    </svg>
  );
};

export default CircleArrowRightIcon;
